export const DEFAULT_I18NEXT_NAMESPACE = 'translation';
export const DEFAULT_LOCALE = 'en';
export const LANG_REGEX = /^(?:\/)?([a-z]{2}(?:-[a-z]{2})?)\/|^(?:\/)?([a-z]{2}(?:-[a-z]{2})?)$/;
